import { useNavigate } from 'react-router-dom';
import { AppNav } from '../components/AppNav';
import { AppShell } from '../components/shell';
import { useLayoutConfig } from '../contexts/LayoutContext';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { LiveMeetingPane } from '../features/live-meeting/components/LiveMeetingPane';
import { useWorkspaceAdmin } from '../hooks/useWorkspaceAdmin';

/**
 * ProductPage - Product module home page
 *
 * Placeholder experience for the Product module.
 * This page is the entry point when the active module is 'product'.
 *
 * Future work:
 * - Roadmaps
 * - Feedback
 * - Product analytics
 */
function ProductPageContent() {
  const navigate = useNavigate();
  const { workspace } = useWorkspace();
  const isWorkspaceAdmin = useWorkspaceAdmin(workspace);

  // No context pane on this page; reset volatile layout state on unmount.
  useLayoutConfig({ showContextPane: false });

  const leftNav = (
    <AppNav
      selected="primary"
      isWorkspaceAdmin={isWorkspaceAdmin}
      onAdministrationClick={() => navigate('/administration')}
    />
  );

  const main = (
    <div className="ss-panel-scroll">
      <LiveMeetingPane />
    </div>
  );

  return <AppShell leftNav={leftNav} main={main} suppressModuleChat />;
}

/**
 * ProductPage - exported page component
 *
 * Wrapped by ProtectedRoute in App.tsx.
 */
export function ProductPage() {
  return <ProductPageContent />;
}
